import { Component, inject } from '@angular/core';
import { LoadingService } from '@services/core/loading.service';

@Component({
  selector: 'full-screen-loading',
  standalone: true,
  template: `
    @if (loadingService.loading()) {
      <div class="fullscreen-loader">
        <div class="fullscreen-loader-content">
          <img src="/assets/favicon.png" alt="Logo" class="fullscreen-loader-logo" />
          <div class="fullscreen-loader-spinner">
            <span class="spinner"></span>
          </div>
        </div>
      </div>
    }
  `,
  styles: [`
    .fullscreen-loader {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      animation: fadeIn 0.2s ease-in-out;
    }

    .fullscreen-loader-content {
      text-align: center;
    }

    .fullscreen-loader-logo {
      width: 80px;
      height: 80px;
      margin-bottom: 24px;
      object-fit: contain;
    }

    .fullscreen-loader-spinner {
      display: flex;
      justify-content: center;
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to   { opacity: 1; }
    }
  `]
})
export class FullScreenLoadingComponent {
  protected loadingService = inject(LoadingService)
}
